module.exports = __webpack_public_path__ + "img/classic_7.b0749101.png";